import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../../services/data.service';
import { OrderByPipe } from '../../../pipes/order-by.pipe';
import { FindContribuenteComponent } from '../find-contribuente/find-contribuente.component';

import { Person } from '../../../models/person';

@Component({
	selector: 'app-contribuente-locatari',
	templateUrl: './contribuente-locatari.component.html',
	styleUrls: ['./contribuente-locatari.component.css']
})
export class ContribuenteLocatariComponent implements OnInit {
	@Input() data: any = null;
	@Input() writePermission: boolean = false;
	@ViewChild('locModal') locModal: ModalDirective;
	//comuneSync: Subscription;
	//comune_id = -1;
	person = new Person();
	locatari: any[] = [];
	editable: any = {};
	newEditPerson: boolean[] = [];

	constructor(private dataService: DataService) { }

	ngOnInit() {
		this.person = new Person();
		/*this.comuneSync = this.dataService.comune$.subscribe(
			comune => {
				this.comune_id = comune.id;
			});
		*/
	}

	ngOnChanges(changes: any){
		let idPerson = null;
		if (changes.data) {
			idPerson = this.data.idPerson;
			console.log("LOCATARI|CHANGES", changes.data.idPerson, idPerson);
			if(changes.data.idPerson && idPerson > 0){
				this.locatari = this.dataService.getLocatariByPersonId(idPerson);

				this.dataService.getPersonById(idPerson, (person) => {
					if (person) {
						this.person = person;
					}
					else {
						this.person = new Person(idPerson);
					}
				});
			}
		}
	}

	aggiungiLocatario(event: any){
		let locatario = event.content;
		this.locatari.push(locatario);
		this.newEditPerson[locatario.id] = true;
		this.modificaLocatario(locatario);
	}

	modificaLocatario(locatario: any){
		this.editable[locatario.id] = true;
	}

	discard(locatario: any){
		this.editable[locatario.id] = false;
	}

	commit(locatario: any){
		this.editable[locatario.id] = false;
	}

	eliminaLocatario(locatario: any){
		let what = locatario;
		let index = this.locatari.indexOf(what);
		if(index !== -1){
			this.locatari.splice(index, 1);
		}
	}

	reset(){
		for (let locatario of this.locatari){
			this.editable[locatario.id] = false;
			this.newEditPerson[locatario.id] = false;
		}
	}

	show() {
		this.reset();
		this.locModal.show();
	}

	hide(){
		this.locModal.hide();
	}

	ngOnDestroy() {
		//this.comuneSync.unsubscribe();
	}
}
